/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C2_DescInputs */

const en_cad_learn_c2_desc = /** @type {(inputs: Cad_Learn_C2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snaps, offset, trim, fillet and grips: the everyday editing toolkit.`)
};

/**
* | output |
* | --- |
* | "Snaps, offset, trim, fillet and grips: the everyday editing toolkit." |
*
* @param {Cad_Learn_C2_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c2_desc = /** @type {((inputs?: Cad_Learn_C2_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C2_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c2_desc(inputs)
});
export { cad_learn_c2_desc as "cad.learn.c2_desc" }